import React from 'react';
import PlusIcon from '../../assets/images/utility-icons/plus2.svg?react';
import SubmitIcon from '../../assets/images/submit-register-icon.svg?react';

import './UploadFile.css';
import { Field } from 'formik';

const UploadFile = ({ label, onChange, hasError }) => {
  const [isFileUploaded, setIsFileUploaded] = React.useState(false);

  const checkIfFileUploaded = (e) => {
    if (e) {
      if (e.target.files.length > 0) {
        setIsFileUploaded(true);
      } else {
        setIsFileUploaded(false);
      }
    }
  };

  return (
    <div className={'UploadFile_form'}>
      <div>{isFileUploaded && !hasError ? <SubmitIcon /> : <PlusIcon />}</div>
      <label htmlFor="upload">{label}</label>
      <Field
        type="file"
        name="upload"
        id="upload"
        onChange={(e) => {
          checkIfFileUploaded(e);
          onChange(e);
        }}
      />
    </div>
  );
};

export default UploadFile;
